import { ComponentFactory } from '@angular/core';


export class SharedViewComponent {
  constructor(public componentFactory: ComponentFactory<any>, public order: number) { }
}
